import React, { ReactNode } from 'react';

interface HelpCardProps {
  children: ReactNode;
  className?: string;
}

const HelpCard: React.FC<HelpCardProps> = ({ children, className = '' }) => {
  return (
    <div className={`bg-white p-4 md:p-6 rounded-2xl shadow-md ${className}`}>
      {children}
    </div>
  );
};

export default HelpCard;